import React, { Component } from "react";
import map from "lodash/map";
import Tooltip from "rc-tooltip";
import ActionInfo from "material-ui/svg-icons/action/info-outline";

class TreePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: null,
    };
  }

  componentDidMount() {
    this.setState({
      indexKey: this.props.selectedId,
    });
    if (this.props.selectedId) {
      this.props.onClick(this.props.selectedId);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedId !== this.props.selectedId &&
      this.state.indexKey !== this.props.selectedId
    ) {
      this.setState({
        indexKey: this.props.selectedId,
      });
    }
  }

  render() {
    return (
      <div
        key={this.props.key + "-tree-node-contianer"}
        style={{ width: "300px", height: "520px", overflowY: "scroll" }}
        className="light-grey-border"
      >
        <div
          className="pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>
            <strong>{this.props.title}</strong>
          </div>
          <div style={{ height: "24px" }}>
            {this.props.tooltip && (
              <Tooltip
                placement="right"
                overlay={this.props.tooltip}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
              >
                <div
                  style={{
                    display: "inline-block",
                    color: "#1E88E5",
                    cursor: "pointer",
                  }}
                >
                  <ActionInfo />
                </div>
              </Tooltip>
            )}
          </div>
        </div>
        {map(this.props.displayData.filter(l => l.id !== 6), data => {
          let clsName = " ml-10 mr-10";
          return (
            <div
              key={this.props.key + data.name + data.id}
              style={{ color: "#017FB5", cursor: "pointer", display: "flex" }}
              className={clsName}
              onClick={() => {
                this.setState({
                  indexKey: data.id,
                });
                this.props.onClick(data.id);
              }}
            >
              <div
                className="pt-10 pl-10 pr-10 pb-10 mr-10"
                style={{
                  background:
                    this.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
                  flexGrow: "1",
                }}
              >
                {data.name}
              </div>
              <div className="tree-node-arrow-right"></div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default TreePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/TreePanel.js